export default __webpack_public_path__ + "1533ba3b478954c58a2f1b656cedb963.png";